module.exports = __webpack_public_path__ + "img/product5.effcb3e6.png";